var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplorative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1268_6769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H81.9141V80.8642H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1268_6769)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1268_6769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 82,
    height: 83
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: -0.0966797,
    width: 81.9141,
    height: 81.2682,
    fill: "url(#pattern0_1268_6769)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1268_6769)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: -0.0966797,
    width: 81.9141,
    height: 81.2682,
    fill: "url(#pattern1_1268_6769)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1268_6769",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(0.00123457 0.00123609)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1268_6769",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(0.00123457 0.00123609)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1268_6769",
    width: 810,
    height: 809,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1268_6769",
    width: 810,
    height: 809,
    preserveAspectRatio: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorative);
export default __webpack_public_path__ + "static/media/EXPLORATIVE.e0659ad582b752952dc69f64aaec720f.svg";
export { ForwardRef as ReactComponent };